import * as React from 'react'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { Image, carLoading } from 'Components/view-image'
import dynamic from 'next/dynamic'
import TryCatchRender from 'Components/try-catch-render'
import FontSize10 from 'Components/font-size-10'
import classNames from 'classnames'
import Avatar from 'Components/author/avatar'
import styleModule from './value-card.module.scss'
const RadarChart = dynamic(() => import('Components/radar-charts-new'), {
  ssr: false,
})
const Stars = dynamic(() => import('./stars'), {
  ssr: false,
})

const star = require('static/yellow-star.png')
const star_black = require('static/black-star-little.png')

interface ISeriesReview {
  comfort_score: number
  appearance_score: number
  configuration_score: number
  control_score: number
  power_score: number
  space_score: number
  interiors_score: number
  score: number
}

export interface ICarReview {
  series_id: number
  series_name: string
  author_info: {
    user_id: number
    user_name: string
    avatar_url: string
    auth_info: string
  }
  related_group_id: {
    group_count: number
    group_list: string[]
  }
  cover_url: string
  score: number
  content: string
  comfort_score: number
  appearance_score: number
  configuration_score: number
  control_score: number
  power_score: number
  space_score: number
  interiors_score: number
  is_new_energy: boolean // 是否是新能源
  series_type: number //车系类型 0 轿车 1 suv 2 mpv
  car_id: number
  car_name: string //车型名称
  year: number
  top?: string
  right?: string
  rank?: number // 分页页数
  item_rank?: number // list 排序
  total_review_count: number
  series_review: ISeriesReview
  group_id_str: string
}

interface IConfig {
  appearance_score: number
  power_score: number
  control_score: number
  comfort_score: number
  space_score: number
  configuration_score: number
  interiors_score: number
  score: number
  [key: string]: number
}

export default TryCatchRender(function ValueCard(props: ICarReview) {
  const {
    score,
    author_info,
    series_name,
    series_id,
    content,
    cover_url,
    appearance_score,
    power_score,
    control_score,
    comfort_score,
    space_score,
    configuration_score,
    interiors_score,
    related_group_id,
    car_id,
    car_name,
    rank,
    item_rank,
    total_review_count,
    year,
    series_review,
    group_id_str: group_id,
  } = props

  const scoreObj: IConfig = {
    appearance_score,
    power_score,
    control_score,
    comfort_score,
    space_score,
    configuration_score,
    interiors_score,
    score,
  }

  const scorePartial = score / 500.0

  const review_detail_url = `/koubei/${group_id}`
  const car_model_url = `/auto/series/${series_id}/model-${car_id}`
  const score_url = `/auto/series/score/${series_id}-x-x-x-x-x`
  const author_profile_url = `/user/${author_info?.user_id}`

  const [showStatus, setShowStatus] = React.useState(false)

  return (
    <div className={styleModule['card']}>
      <div
        className={`${styleModule['top-card-bg']} top-card-bg`}
        onMouseEnter={() => {
          setTimeout(() => {
            setShowStatus(true)
          }, 140)
        }}
        onMouseLeave={() => {
          setTimeout(() => {
            setShowStatus(false)
          }, 200)
        }}
      >
        <div
          onClick={() => {
            window.open(score_url, '_blank')
            sendTeaCommEvent('clk_event', {
              event_id: 'dscore_module_item_card',
              car_series_id: `${series_id}`,
              car_series_name: series_name,
              group_id: `${group_id}`,
              rank: `${rank}`,
              item_rank: `${item_rank}`,
              module_id: 'dscore_module',
              author_id: `${author_info.user_id}`,
            })
          }}
        >
          <div className={`${styleModule['score-wrap']} score-wrap`}>
            <p className={styleModule['mark']}>
              {(series_review?.score / 100.0)?.toFixed(2)} <span>分</span>
            </p>
          </div>
          <p
            className={styleModule['top-card-info']}
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              window.open(score_url, '_blank')
            }}
          >
            全部评分
            <i className="DCD_Icon icon_into_12 tw-text-14 tw-ml-2" />
          </p>
          <div className={styleModule['top-bottom-wrap']}>
            <div className={styleModule['car-cover']}>
              <Image
                className={styleModule['car-cover-img']}
                src={cover_url}
                lazy={true}
                width={129}
                height={86}
                alt={series_name}
                cusDefaultImg={carLoading}
              />
            </div>
            <div className={styleModule['top-car-name-wrap']}>
              <p className={`${styleModule['card-title']} g-one-line-text`}>
                {series_name}
              </p>
              <p className="tw-text-common-black g-one-line-text">
                {total_review_count
                  ? `共${total_review_count}人评分`
                  : '暂无评分'}
              </p>
            </div>
          </div>
          <div className={styleModule['chart-wrap']}>
            {showStatus && (
              <RadarChart
                theStyle={{
                  height: '235px',
                  width: '210px',
                  margin: '0 auto',
                }}
                comfort_score={series_review?.comfort_score}
                appearance_score={series_review?.appearance_score}
                configuration_score={series_review?.configuration_score}
                control_score={series_review?.control_score}
                power_score={series_review?.power_score}
                space_score={series_review?.space_score}
                interiors_score={series_review?.interiors_score}
                score={series_review?.score}
                type={'home'}
              />
            )}
          </div>
        </div>
      </div>
      <div className={styleModule['content-wrap']}>
        <div className={styleModule['user-info-wrap']}>
          <a
            target={'_blank'}
            href={author_profile_url}
            onClick={() => {
              sendTeaCommEvent('clk_event', {
                event_id: 'dscore_module_item_profile',
                car_series_id: `${series_id}`,
                car_series_name: series_name,
                group_id,
                rank,
                item_rank,
                module_id: 'dscore_module',
                author_id: `${author_info.user_id}`,
              })
            }}
          >
            <Avatar
              size={24}
              avatar={author_info?.avatar_url}
              username={author_info?.user_name}
              className="tw-mr-6 tw-z-10 tw-align-middle tw-cursor-pointer"
            />
          </a>
          <span
            className={`${styleModule['user-info-wrap-text']} g-one-line-text`}
          >
            <a
              target={'_blank'}
              href={author_profile_url}
              onClick={() => {
                sendTeaCommEvent('clk_event', {
                  event_id: 'dscore_module_item_profile',
                  car_series_id: `${series_id}`,
                  car_series_name: series_name,
                  group_id,
                  rank,
                  item_rank,
                  module_id: 'dscore_module',
                  author_id: `${author_info.user_id}`,
                })
              }}
            >
              <span className={styleModule['author-name']}>
                {`${author_info?.user_name} `}
              </span>
            </a>
          </span>
          <span className={styleModule['car-name-before']}>点评车型</span>
        </div>
        <div className={styleModule['car-name-and-score']}>
          <a
            target={'_blank'}
            href={review_detail_url}
            onClick={() => {
              sendTeaCommEvent('clk_event', {
                event_id: 'dscore_module_item_series',
                car_series_id: `${series_id}`,
                car_series_name: series_name,
                group_id,
                rank,
                item_rank,
                module_id: 'dscore_module',
                author_id: `${author_info.user_id}`,
              })
            }}
          >
            <p className={`${styleModule['car-name-wrap']} g-one-line-text`}>
              <span className={`${styleModule['car-name']} g-one-line-text`}>
                {year ? `${year}款` : ''}
                {car_name}
              </span>
            </p>
            <p className={styleModule['car-score']}>
              <span className={styleModule['score']}>
                {(score / 100.0)?.toFixed(2)}
              </span>
              <FontSize10>分</FontSize10>
            </p>
            <div className={styleModule['car-star']}>
              <Stars
                starIcon={star}
                starVacantIcon={star_black}
                score={score / 100.0}
                maxScore={5}
                starWidth={8}
                starHeight={8}
              />
            </div>
          </a>
        </div>
        <a target={'_blank'} href={review_detail_url}>
          <p
            className={classNames(
              styleModule['content'],
              'line-3',
              group_id === '' ? 'tw-cursor-auto' : 'tw-cursor-pointer'
            )}
            onClick={() => {
              sendTeaCommEvent('clk_event', {
                event_id: 'dscore_module_item_card',
                car_series_id: `${series_id}`,
                car_series_name: series_name,
                group_id,
                rank,
                item_rank,
                module_id: 'dscore_module',
                author_id: `${author_info.user_id}`,
              })
            }}
          >
            {content}
          </p>
        </a>
      </div>
      <style jsx>
        {`
          .top-card-bg {
            background-image: url(${require('./static/score-bg.png')});
          }
          .score-wrap {
            background: url(${require('./static/new-car-bg.png')}) no-repeat 0 0 /
              cover;
          }
        `}
      </style>
    </div>
  )
})
